import {
    AfterViewInit, ChangeDetectorRef,
    Component,
    ComponentFactoryResolver,
    Directive,
    ElementRef, EventEmitter, Inject,
    Input, OnChanges,
    OnInit,
    Output,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {MAT_DIALOG_DATA, MatDialog, MatSnackBar} from '@angular/material';
import {KongService} from '../kong.service';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {Router} from '@angular/router';
import {ListenerService} from '../listener.service';
import {DeploymentplanListenerService} from '../deploymentplan-listener.service';
import {DataaccessListenerService} from '../dataaccess-listener.service';
import {CrudapiComponent} from '../crudapi/crudapi.component';
import {WebsocketService} from '../websocket.service';
import {ApiCreatorsService} from '../api-creators.service';
import {ProgressLogsComponent} from '../progress-logs/progress-logs.component';
import {InjectDirective} from '../components/home/resources/resources.component';
import {ConfirmResetAPIRegisterComponent} from '../api-register/api-register.component';
import {MatChipInputEvent} from '@angular/material';
import {ENTER, COMMA} from '@angular/cdk/keycodes';
import {environment} from '../../environments/environment';
import {EntityVersionChangeConfirmationComponent} from '../edit-entity/edit-entity.component';
import {DeploymentSummaryComponent} from './deployment-summary/deployment-summary.component';
import {AuthedApiService} from '../authed-api.service';
import {AccountInfoService} from '../user/account-info.service';


const incr = 7;

export interface Menu {
    name: string;
    iconClass: string;
    active: boolean;
    checked: boolean;
    toolTip: string;
    submenu: { name: string, version: string, key: string, icon: string, isAvailable: boolean, checked: boolean, deployStarted: boolean, deployed: string, toolTip: string, showQueryLogs: boolean, type: string, index: number, planIndex: number }[];
}

@Directive({
    selector: '[logInject]'
})
export class InjectLogsDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}

@Component({
    selector: 'app-deploymentplan',
    templateUrl: './deploymentplan.component.html',
    styleUrls: ['./deploymentplan.component.css']
})
export class DeploymentplanComponent implements AfterViewInit, OnChanges {

    dataMigration = false;
    @Input() deploymentPlan: any;
    @Input() title = 'Digital Transformation Plan';
    apiExecutorPlans: any;
    entityPlans: any;
    dataMigrationPlans: any;
    requestModel: any;
    showStatusPanel = false;
    showResultsPage = false;
    deploymentResults: any;
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() pkey = localStorage.getItem('partnerKey');
    @Input() email = localStorage.getItem('signInEmail');
    session = localStorage.getItem('sessionID');
    progress = 0;
    progressMessage: string;
    entities: any;
    entityTypes = [];
    databases: any;
    datatypes: any;
    databaseNames = [];
    dataTypeFilter = [];
    selectedDatatypeFilter: string;
    @Input() selectedDatabase = 'default';
    @Input() referentialKeyOptionSelected: any;
    @Input() isTransform = true;
    @Input() applicationData: any;
    @Input() categoriesData: any;
    origApplicationData: any;
    categoryResponse: any;
    applicationResponse: any;
    @Input() type: any;
    @Input() editFlag = false;
    @Output() goBack: EventEmitter<any> = new EventEmitter<any>();
    timeStamp: any;
    isToggleExpanded = false;

    sourceDatabaseLabel = 'Source Database: ';
    targetDatabaseLabel = 'Target Database: ';

    enableTransform = true;
    loaderDialog: any;

    componentLoading = true;
    loading = false;
    selectedEntityPlan: any;
    selectedDataMigrationPlan: any;
    selectedApiExecutorPlan: any;
    selectedMenuItem: any;
    tabData = [];
    currentTabIndex: any;
    renderedTables = [];
    renderedDataAccessAPIs = [];
    renderedBusinessLogicAPIs = [];
    renderedSQLQueryAPIs = [];
    renderedPLSQLQueryAPIs = [];
    renderedWorkFlowAPIs = [];
    renderedThirdpartyAPIs = [];
    activeTabIndex = 0;
    flaggedEntities = [];
    flaggedSql = [];
    flaggedWorkflow = [];
    defaultActiveMenu = '';
    depolymentLoading = false;

    deploymentPlanMenu: Menu[] = [{
        name: 'Tables',
        iconClass: 'fa fa-table',
        active: false,
        checked: true,
        toolTip: '',
        submenu: []
    },
        {
            name: 'Views',
            iconClass: 'fa fa-eye',
            active: false,
            checked: true,
            toolTip: '',
            submenu: []
        },
        {
            name: 'Procedures',
            iconClass: 'fa fa-tasks',
            active: false,
            checked: true,
            toolTip: '',
            submenu: []
        },
        {
            name: 'Indexes',
            iconClass: 'fa fa-calendar',
            active: false,
            checked: true,
            toolTip: '',
            submenu: []
        },
        {
            name: 'Triggers',
            iconClass: 'fa fa-bolt',
            active: false,
            checked: true,
            toolTip: '',
            submenu: []
        }];
    logVisible = false;
    entityName: any;
    version: any;
    currentMessage: any;
    apiType = 'DATAACCESS';
    connection: any;
    action: any;
    entitiesToBeTransformed = [];
    executorsToBeTransformed = [];
    Blocks = [];
    BlockList = {
        '1': 0,
        '2': 25,
        '3': 50,
        '4': 75,
        '5': 100
    };
    destroy: any;
    guard;
    isWebSocketConnectionEstablished = false;
    componentRef;
    @ViewChild(InjectLogsDirective, {static: false}) injectComp: InjectLogsDirective;

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;

    // Enter, comma
    separatorKeysCodes = [ENTER, COMMA];

    serverUrls = [];

    constructor(private confPost: ConfService, private router: Router,
                private apiService: AuthedApiService,
                private accountInfoService: AccountInfoService,
                private kongService: KongService, public deploymentPlanListenerInstance: DeploymentplanListenerService,
                private websocketService: WebsocketService,
                private apiCreatorService: ApiCreatorsService,
                private host: ElementRef,
                private changeDetector: ChangeDetectorRef,
                private _componentFactoryResolver: ComponentFactoryResolver,
                private _service: ConnecttocrudService, public dialog: MatDialog, public leftPanelDataListener: ListenerService, private dataAccessListenerInstance: DataaccessListenerService, public crudAPIComponent: CrudapiComponent,
                private platform: LeftpanelComponent) {


        this.apiCreatorService.eventCallback$.subscribe(value => {

            // if (value.apiName === this.executor_name && value.apiVersion === this.selectedVersion) {
            //     this.loading1 = false;

            this.isWebSocketConnectionEstablished = false;
            //
            if (value.result === 'failure') {
                //this.displaySnackBarWithWS('Error', 5000, value.message);
                this.setAPIDeploymentStatus(value.apiName, value.apiVersion, value.result);

            } else if (value.result === 'success') {
                this.setAPIDeploymentStatus(value.apiName, value.apiVersion, value.result);
                // this.Blocks = [1, 2, 4, 5];
                // const blockLength = this.Blocks.length;
                // const blockStart = this.BlockList[this.Blocks[0]];
                // const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                // this.progress = blockStart;
                // this.leftPanelDataListener.changeInLeftPanelDataV2.emit('sql');

                //this.setInterval(blockEnd, true);
            }
            if (this.websocketService.isOpen()) {
                this.isWebSocketConnectionEstablished = true;
            }
            //}
        });
    }

    setAPIDeploymentStatus(apiName, apiVersion, status) {
        if (this.entityPlans && this.entityPlans.length) {
            for (let i = 0; i < this.entityPlans.length; i++) {
                if (this.entityPlans[i].entity.entityname === apiName && this.entityPlans[i].entity.version === apiVersion) {
                    if (status === 'loading') {
                        this.deploymentPlanMenu[0].submenu[i].deployed = 'loading';
                    } else {
                        if (status === 'failure') {
                            this.deploymentPlanMenu[0].submenu[i].deployed = 'error';
                            this.deploymentPlanMenu[0].submenu[i]['database'] = this.entityPlans[i].entity.database;
                        } else if (status === 'success') {
                            this.entityPlans[i]['isAvailable'] = true;
                            this.deploymentPlanMenu[0].submenu[i].isAvailable = true;
                            this.deploymentPlanMenu[0].submenu[i].deployed = 'success';
                            this.deploymentPlanMenu[0].submenu[i]['database'] = this.entityPlans[i].entity.database;
                        }
                        this.deploymentPlanMenu[0].submenu[i].showQueryLogs = true;
                    }
                }
            }
        }
        if (this.apiExecutorPlans && this.apiExecutorPlans.length) {

            for (let i = 0; i < this.apiExecutorPlans.length; i++) {
                const that = this;
                const matches = this.deploymentPlanMenu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu.filter(function (e) {
                    return e.name === that.apiExecutorPlans[i].apiExecutor.executor_name && e.version === that.apiExecutorPlans[i].apiExecutor.executor_version;
                });
                if (this.apiExecutorPlans[i].apiExecutor.executor_name === apiName && this.apiExecutorPlans[i].apiExecutor.executor_version === apiVersion) {
                    if (status === 'loading') {
                        this.deploymentPlanMenu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index].deployed = 'loading';
                    } else {
                        if (status === 'failure') {
                            this.deploymentPlanMenu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index].deployed = 'error';
                        } else if (status === 'success') {
                            this.apiExecutorPlans[i]['isAvailable'] = true;
                            this.deploymentPlanMenu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index].isAvailable = true;
                            this.deploymentPlanMenu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index].deployed = 'success';
                        }
                        this.deploymentPlanMenu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index].showQueryLogs = true;

                    }
                }
            }
        }

    }


    setInterval(blockEnd, nextPanel) {
        // this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
        this.destroy = setInterval(() => this.manageProgress(), 1000);
    }

    getEntitiesForPartnerAccount(partner, account) {
        this.entities = this.platform.partnerEntities;
        this.entityTypes = this.platform.partnerEntityTypes;
        // this.confPost.getEntitiesForPartnerAccount(partner, account).subscribe(data => {
        //   this.entities = data;
        //   this.entities.forEach(entity => {
        //     this.entityTypes.push(entity.entityname + '_' + entity.version);
        //   });
        // });
    }

    async ngOnChanges() {
        this.setMenu();
    }

    async ngAfterViewInit() {
        this.changeDetector.detectChanges();
        if (this.websocketService.isOpen()) {
            this.isWebSocketConnectionEstablished = true;
        }
        this.guard = 0;
        if (this.deploymentPlan) {
            this.apiExecutorPlans = this.deploymentPlan.executorModelDeploymentPlans;
            this.entityPlans = this.deploymentPlan.entityDeploymentPlans;
            this.dataMigrationPlans = this.deploymentPlan.dataMigrationPlans;
            this.requestModel = this.deploymentPlan.requestModel;
        }
        this.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'));
        if (this.entityPlans) {
            this.entityPlans.forEach(entityPlan => {
                this.entityTypes.push(entityPlan.entity.entityname + '_' + entityPlan.entity.version);
            });
        }

        if (this.type === 'openAPI') {
            this.applicationData.servers.forEach(server => {
                this.serverUrls.push(server.url);
            });

            if (this.applicationData) {
                this.origApplicationData = JSON.parse(JSON.stringify(this.applicationData));
            }
        }

        const tempEntities = [];
        if (this.entityPlans) {
            this.entityPlans.forEach(entityPlan => {
                if (entityPlan) {
                    if (tempEntities.indexOf(entityPlan.entity.entityname + '_' + entityPlan.entity.version) === -1) {
                        tempEntities.push(entityPlan.entity.entityname + '_' + entityPlan.entity.version);
                        entityPlan.entity['canShow'] = true;
                    } else {
                        entityPlan.entity['canShow'] = false;
                    }
                    if (entityPlan.dependencies) {
                        entityPlan.dependencies.forEach(dependency => {
                            if (dependency) {
                                if (tempEntities.indexOf(dependency.entity.entityname + '_' + dependency.entity.version) === -1) {
                                    tempEntities.push(dependency.entity.entityname + '_' + dependency.entity.version);
                                    dependency.entity['canShow'] = true;
                                } else {
                                    dependency.entity['canShow'] = false;
                                }
                            }
                        });
                    }
                    if (entityPlan.referers) {
                        entityPlan.referers.forEach(referer => {
                            if (referer) {
                                if (tempEntities.indexOf(referer.entity.entityname + '_' + referer.entity.version) === -1) {
                                    tempEntities.push(referer.entity.entityname + '_' + referer.entity.version);
                                    referer.entity['canShow'] = true;
                                } else {
                                    referer.entity['canShow'] = false;
                                }
                            }
                        });
                    }
                }
            });
        }

        if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
            this.datatypes = this.platform.datatypes;
        } else {
            await this.platform.getDataTypesForPartnerAccount();
            this.datatypes = this.platform.datatypes;
        }

        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            this.databases = this.platform.databases;
        } else {
            await this.platform.getDatabasesForPartnerAccount();
            this.databases = this.platform.databases;
        }
        for (const database of this.databases) {
            this.databaseNames.push(database.database_name);
        }
        this.dataTypeFilter = [];
        this.datatypes.filter(items => {
            if (items.database_type === this.selectedDatatypeFilter) {
                this.dataTypeFilter.push(items);
            }
        });
        if (this.selectedDatatypeFilter === 'mongodb') {
            this.entityTypes.forEach(entityType => {
                const newType = {
                    'database_type': 'mongodb',
                    'data_types': [
                        {
                            'type': entityType,
                            'default_length': '',
                            'min_length': '',
                            'max_length': ''
                        }]
                };
                this.dataTypeFilter.push(newType);
            });
        }

        this.componentLoading = false;
        if (this.entityPlans && this.entityPlans.length) {
            this.defaultActiveMenu = this.entityPlans[0].entity.entityname;
            this.selectedEntityPlan = this.entityPlans[0];
        } else if (this.apiExecutorPlans && this.apiExecutorPlans.length) {
            this.defaultActiveMenu = this.apiExecutorPlans[0].apiExecutor.executor_name;
        }
        if (this.dataMigrationPlans && this.dataMigrationPlans.length) {
            this.selectedDataMigrationPlan = this.dataMigrationPlans[0];
        }
        this.setMenu();
    }

    setMenu() {
        if (this.type === 'database') {
            if (this.entityPlans && this.entityPlans.length) {
                for (const entityPlan of this.entityPlans) {
                    this.deploymentPlanMenu[0].submenu.push({
                        name: entityPlan.entity.entityname,
                        version: entityPlan.entity.version,
                        key: '',
                        icon: '',
                        checked: true,
                        isAvailable: entityPlan.isAvailable,
                        deployStarted: false,
                        deployed: 'loading',
                        toolTip: entityPlan.entity.entityname,
                        showQueryLogs: false,
                        type: '',
                        index: 0,
                        planIndex: 0
                    });
                }
                if (this.entityPlans && this.entityPlans.length > 0) {
                    const tabData = {};
                    this.selectedEntityPlan = this.entityPlans[0];
                    // this.selectedDataMigrationPlan = this.dataMigrationPlans[0];
                    tabData['type'] = 'tables';
                    tabData['selectedEntityPlan'] = this.entityPlans[0];
                    tabData['selectedDataMigrationPlan'] = this.dataMigrationPlans ? this.dataMigrationPlans.length > 0 ? this.dataMigrationPlans[0] : null : null;
                    tabData['index'] = 0;
                    this.renderedTables.push(0);

                    if (Object.keys(tabData).length) {
                        this.tabData.push(tabData);
                        this.activeTabIndex = this.tabData.length - 1;
                    }
                }
            }
        } else {
            this.deploymentPlanMenu = [{
                name: 'Data Access APIs',
                iconClass: 'fa fa-table',
                active: true,
                checked: true,
                toolTip: '',
                submenu: []
            },
                {
                    name: 'Business Logic APIs',
                    iconClass: 'fa fa-link',
                    active: true,
                    checked: true,
                    toolTip: '',
                    submenu: []
                },
                {
                    name: 'SQL Query APIs',
                    iconClass: 'fa fa-database',
                    active: true,
                    checked: true,
                    toolTip: '',
                    submenu: []
                },
                {
                    name: 'Workflow APIs',
                    iconClass: 'fa fa-sitemap',
                    active: true,
                    checked: true,
                    toolTip: '',
                    submenu: []
                },
                {
                    name: 'PLSQL APIs',
                    iconClass: 'fa fa-tasks',
                    active: true,
                    checked: true,
                    toolTip: '',
                    submenu: []
                },
                {
                    name: 'Thirdparty APIs',
                    iconClass: 'fa fa-rocket',
                    active: true,
                    checked: true,
                    toolTip: '',
                    submenu: []
                }];
            if (this.entityPlans && this.entityPlans.length) {
                this.entityPlans.forEach((entityPlan, index) => {
                    this.deploymentPlanMenu[0].submenu.push({
                        name: entityPlan.entity.entityname,
                        version: entityPlan.entity.version,
                        key: '',
                        icon: '',
                        type: 'entity',
                        isAvailable: entityPlan.isAvailable,
                        index: index,
                        planIndex: index,
                        checked: entityPlan.deploy_api,
                        deployStarted: false,
                        deployed: 'loading',
                        toolTip: entityPlan.entity.entityname,
                        showQueryLogs: false
                    });
                });
            }
            if (this.apiExecutorPlans && this.apiExecutorPlans.length) {
                this.apiExecutorPlans.forEach((apiExecutorPlan, index) => {
                    if (apiExecutorPlan.apiExecutor.executor_type === 'BUSINESSLOGIC') {
                        this.deploymentPlanMenu[this.getMenuIndex(apiExecutorPlan.apiExecutor.executor_type)].submenu.push({
                            name: apiExecutorPlan.apiExecutor.executor_name,
                            version: apiExecutorPlan.apiExecutor.executor_version,
                            key: '',
                            icon: '',
                            isAvailable: apiExecutorPlan.isAvailable,
                            type: 'executor',
                            index: this.deploymentPlanMenu[this.getMenuIndex(apiExecutorPlan.apiExecutor.executor_type)].submenu.length,
                            planIndex: index,
                            checked: apiExecutorPlan.deploy_api,
                            deployStarted: false,
                            deployed: 'loading',
                            toolTip: apiExecutorPlan.apiExecutor.executor_name,
                            showQueryLogs: false
                        });
                    } else if (apiExecutorPlan.apiExecutor.executor_type === 'SQLQUERY') {
                        this.deploymentPlanMenu[this.getMenuIndex(apiExecutorPlan.apiExecutor.executor_type)].submenu.push({
                            name: apiExecutorPlan.apiExecutor.executor_name,
                            version: apiExecutorPlan.apiExecutor.executor_version,
                            key: '',
                            icon: '',
                            type: 'executor',
                            isAvailable: apiExecutorPlan.isAvailable,
                            index: this.deploymentPlanMenu[this.getMenuIndex(apiExecutorPlan.apiExecutor.executor_type)].submenu.length,
                            planIndex: index,
                            checked: apiExecutorPlan.deploy_api,
                            deployStarted: false,
                            deployed: 'loading',
                            toolTip: apiExecutorPlan.apiExecutor.executor_name,
                            showQueryLogs: false
                        });
                    } else if (apiExecutorPlan.apiExecutor.executor_type === 'WORKFLOW') {
                        this.deploymentPlanMenu[this.getMenuIndex(apiExecutorPlan.apiExecutor.executor_type)].submenu.push({
                            name: apiExecutorPlan.apiExecutor.executor_name,
                            version: apiExecutorPlan.apiExecutor.executor_version,
                            key: '',
                            icon: '',
                            type: 'executor',
                            isAvailable: apiExecutorPlan.isAvailable,
                            index: this.deploymentPlanMenu[this.getMenuIndex(apiExecutorPlan.apiExecutor.executor_type)].submenu.length,
                            planIndex: index,
                            checked: apiExecutorPlan.deploy_api,
                            deployStarted: false,
                            deployed: 'loading',
                            toolTip: apiExecutorPlan.apiExecutor.executor_name,
                            showQueryLogs: false
                        });
                    } else if (apiExecutorPlan.apiExecutor.executor_type === 'PLSQL') {
                        this.deploymentPlanMenu[this.getMenuIndex(apiExecutorPlan.apiExecutor.executor_type)].submenu.push({
                            name: apiExecutorPlan.apiExecutor.executor_name,
                            version: apiExecutorPlan.apiExecutor.executor_version,
                            key: '',
                            icon: '',
                            type: 'executor',
                            isAvailable: apiExecutorPlan.isAvailable,
                            index: this.deploymentPlanMenu[this.getMenuIndex(apiExecutorPlan.apiExecutor.executor_type)].submenu.length,
                            planIndex: index,
                            checked: apiExecutorPlan.deploy_api,
                            deployStarted: false,
                            deployed: 'loading',
                            toolTip: apiExecutorPlan.apiExecutor.executor_name,
                            showQueryLogs: false
                        });
                    } else if (apiExecutorPlan.apiExecutor.executor_type === 'THIRDPARTY') {
                        this.deploymentPlanMenu[this.getMenuIndex(apiExecutorPlan.apiExecutor.executor_type)].submenu.push({
                            name: apiExecutorPlan.apiExecutor.executor_name,
                            version: apiExecutorPlan.apiExecutor.executor_version,
                            key: '',
                            icon: '',
                            type: 'executor',
                            isAvailable: apiExecutorPlan.isAvailable,
                            index: this.deploymentPlanMenu[this.getMenuIndex(apiExecutorPlan.apiExecutor.executor_type)].submenu.length,
                            planIndex: index,
                            checked: apiExecutorPlan.deploy_api,
                            deployStarted: false,
                            deployed: 'loading',
                            toolTip: apiExecutorPlan.apiExecutor.executor_name,
                            showQueryLogs: false
                        });
                    }
                });
            }
            if (this.entityPlans && this.entityPlans.length) {
                this.deploymentPlanMenu[0].active = true;
                this.selectedMenuItem = {
                    parent: 'Data Access APIs',
                    child: this.entityPlans[0].entity.entityname
                };
                const tabData = {};
                tabData['type'] = 'dataAccessAPIs';
                tabData['selectedEntityPlan'] = this.entityPlans[0];
                tabData['blocklyRendered'] = false;
                tabData['index'] = 0;
                this.renderedDataAccessAPIs.push(0);
                this.tabData.push(tabData);
            } else if (this.apiExecutorPlans && this.apiExecutorPlans.length) {

                if (this.apiExecutorPlans[0].apiExecutor.executor_type === 'BUSINESSLOGIC') {
                    this.deploymentPlanMenu[1].active = true;
                    this.selectedMenuItem = {
                        parent: 'Business Logic APIs',
                        child: this.apiExecutorPlans[0].apiExecutor.executor_name
                    };
                    const tabData = {};
                    tabData['type'] = 'businessLogicAPIs';
                    tabData['selectedApiExecutorPlan'] = this.apiExecutorPlans[0];
                    tabData['blocklyRendered'] = false;
                    tabData['workSpaceId'] = 'blockly' + this.apiExecutorPlans[0].apiExecutor.executor_name;
                    tabData['index'] = 0;
                    this.renderedBusinessLogicAPIs.push(0);
                    this.tabData.push(tabData);
                } else if (this.apiExecutorPlans[0].apiExecutor.executor_type === 'SQLQUERY') {
                    this.deploymentPlanMenu[2].active = true;
                    this.selectedMenuItem = {
                        parent: 'SQL Query APIs',
                        child: this.apiExecutorPlans[0].apiExecutor.executor_name
                    };
                    const tabData = {};
                    tabData['type'] = 'sqlQueryAPIs';
                    tabData['selectedApiExecutorPlan'] = this.apiExecutorPlans[0];
                    tabData['index'] = 0;
                    this.renderedSQLQueryAPIs.push(0);
                    this.tabData.push(tabData);
                } else if (this.apiExecutorPlans[0].apiExecutor.executor_type === 'WORKFLOW') {
                    this.deploymentPlanMenu[3].active = true;
                    this.selectedMenuItem = {
                        parent: 'Workflow APIs',
                        child: this.apiExecutorPlans[0].apiExecutor.executor_name
                    };
                    const tabData = {};
                    tabData['type'] = 'workflowAPIs';
                    tabData['selectedApiExecutorPlan'] = this.apiExecutorPlans[0];
                    tabData['index'] = 0;
                    this.renderedWorkFlowAPIs.push(0);
                    this.tabData.push(tabData);
                } else if (this.apiExecutorPlans[0].apiExecutor.executor_type === 'PLSQL') {
                    this.deploymentPlanMenu[4].active = true;
                    this.selectedMenuItem = {
                        parent: 'PLSQL APIs',
                        child: this.apiExecutorPlans[0].apiExecutor.executor_name
                    };
                    const tabData = {};
                    tabData['type'] = 'plSqlAPIs';
                    tabData['selectedApiExecutorPlan'] = this.apiExecutorPlans[0];
                    tabData['index'] = 0;
                    this.renderedThirdpartyAPIs.push(0);
                    this.tabData.push(tabData);
                } else if (this.apiExecutorPlans[0].apiExecutor.executor_type === 'THIRDPARTY') {
                    this.deploymentPlanMenu[5].active = true;
                    this.selectedMenuItem = {
                        parent: 'Thirdparty APIs',
                        child: this.apiExecutorPlans[0].apiExecutor.executor_name
                    };
                    const tabData = {};
                    tabData['type'] = 'thirdpartyAPIs';
                    tabData['selectedApiExecutorPlan'] = this.apiExecutorPlans[0];
                    tabData['index'] = 0;
                    this.renderedThirdpartyAPIs.push(0);
                    this.tabData.push(tabData);
                }
            }
        }
    }

    getMenuIndex(type) {
        switch (type) {
            case 'BUSINESSLOGIC':
                return 1;
            case 'SQLQUERY':
                return 2;
            case 'WORKFLOW':
                return 3;
            case 'PLSQL':
                return 4;
            case 'THIRDPARTY':
                return 5;
            default:
                return 1;
        }

    }

    getDatabaseTypeForDatabaseName(val) {
        this.databases.filter(items => {
            if (items.database_name === val) {
                this.selectedDatatypeFilter = items.database_type;
            }
        });
    }

    manageProgress() {
        if (this.progress >= 100) {
            this.showStatusPanel = false;
            this.showResultsPage = true;
        } else {
            this.progress = this.progress + incr;
        }
        if (this.progress <= 35) {
            this.progressMessage = 'Setting Up API';
        } else if (this.progress > 35 && this.progress <= 70) {
            this.progressMessage = 'Setting Up Database';
            /*} else if (this.progress > 70 && this.progress <= 98) {
                this.progressMessage = 'Creating dedicated File storage for your account';*/
        } else if (this.progress > 70) {
            this.progressMessage = 'Deploying into Cloud';
        }
    }

    checkForAvailableEntityOrExecutors(partner, account, pkey, APIName, APIVersion) {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.platform.CheckForExistingEntityOrExecutorWithParams(partner, account, pkey, APIName, APIVersion)).then(async resp => {
                resolve('success');
            }, error => {
                if (error.status === 'already exists') {
                    this.platform.openSnackBar('An API with the name ' + APIName + ' and version ' + APIVersion + ' already exists in the partner.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                } else if (error.status === 'failed') {
                    this.platform.openSnackBar('Error while checking API availability in your account. Please try again after sometime.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
                reject('failed');
            });
        });
    }


    onItemSelected(selectedItem) {
        if (selectedItem) {
            this.selectedMenuItem = selectedItem;
            let tabData = {};
            switch (selectedItem.parent) {
                case 'Tables':
                    for (let i = 0; i < this.entityPlans.length; i++) {
                        if (this.entityPlans[i].entity.entityname === selectedItem.child && !this.renderedTables.includes(i)) {
                            this.selectedEntityPlan = this.entityPlans[i];
                            this.selectedDataMigrationPlan = this.dataMigrationPlans[i];
                            tabData['type'] = 'tables';
                            tabData['selectedEntityPlan'] = this.entityPlans[i];
                            tabData['selectedDataMigrationPlan'] = this.dataMigrationPlans[i];
                            tabData['index'] = i;
                            this.renderedTables.push(i);
                            break;
                        }
                    }
                    break;
                case 'Data Access APIs':
                    for (let i = 0; i < this.entityPlans.length; i++) {
                        if (this.entityPlans[i].entity.entityname === selectedItem.child && !this.renderedDataAccessAPIs.includes(i)) {
                            this.selectedEntityPlan = this.entityPlans[i];
                            // this.selectedDataMigrationPlan = this.dataMigrationPlans[i];
                            tabData['type'] = 'dataAccessAPIs';
                            tabData['selectedEntityPlan'] = this.entityPlans[i];
                            tabData['blocklyRendered'] = false;
                            tabData['index'] = i;
                            this.renderedDataAccessAPIs.push(i);
                            break;
                            // tabData['selectedDataMigrationPlan'] = this.dataMigrationPlans[i];
                        }
                    }
                    break;
                case 'Business Logic APIs':
                    for (let i = 0; i < this.apiExecutorPlans.length; i++) {
                        if (this.apiExecutorPlans[i].apiExecutor.executor_name === selectedItem.child && !this.renderedBusinessLogicAPIs.includes(i)) {
                            this.selectedApiExecutorPlan = this.apiExecutorPlans[i];
                            tabData['type'] = 'businessLogicAPIs';
                            tabData['selectedApiExecutorPlan'] = this.apiExecutorPlans[i];
                            tabData['blocklyRendered'] = false;
                            tabData['workSpaceId'] = 'blockly' + this.apiExecutorPlans[i].apiExecutor.executor_name;
                            tabData['index'] = i;
                            this.renderedBusinessLogicAPIs.push(i);
                            break;
                        }
                    }
                    break;
                case 'SQL Query APIs':
                    for (let i = 0; i < this.apiExecutorPlans.length; i++) {
                        if (this.apiExecutorPlans[i].apiExecutor.executor_name === selectedItem.child && !this.renderedSQLQueryAPIs.includes(i)) {
                            this.selectedApiExecutorPlan = this.apiExecutorPlans[i];
                            tabData['type'] = 'sqlQueryAPIs';
                            tabData['selectedApiExecutorPlan'] = this.apiExecutorPlans[i];
                            tabData['index'] = i;
                            this.renderedSQLQueryAPIs.push(i);
                            break;
                        }
                    }
                    break;
                case 'PLSQL APIs':
                    for (let i = 0; i < this.apiExecutorPlans.length; i++) {
                        if (this.apiExecutorPlans[i].apiExecutor.executor_name === selectedItem.child && !this.renderedPLSQLQueryAPIs.includes(i)) {
                            this.selectedApiExecutorPlan = this.apiExecutorPlans[i];
                            tabData['type'] = 'plSqlAPIs';
                            tabData['selectedApiExecutorPlan'] = this.apiExecutorPlans[i];
                            tabData['index'] = i;
                            this.renderedPLSQLQueryAPIs.push(i);
                            break;
                        }
                    }
                    break;
                case 'Workflow APIs':
                    for (let i = 0; i < this.apiExecutorPlans.length; i++) {
                        if (this.apiExecutorPlans[i].apiExecutor.executor_name === selectedItem.child && !this.renderedWorkFlowAPIs.includes(i)) {
                            this.selectedApiExecutorPlan = this.apiExecutorPlans[i];
                            tabData['type'] = 'workflowAPIs';
                            tabData['selectedApiExecutorPlan'] = this.apiExecutorPlans[i];
                            tabData['index'] = i;
                            this.renderedWorkFlowAPIs.push(i);
                            break;
                        }
                    }
                    break;
                case 'Thirdparty APIs':
                    for (let i = 0; i < this.apiExecutorPlans.length; i++) {
                        if (this.apiExecutorPlans[i].apiExecutor.executor_name === selectedItem.child && !this.renderedThirdpartyAPIs.includes(i)) {
                            this.selectedApiExecutorPlan = this.apiExecutorPlans[i];
                            tabData['type'] = 'thirdpartyAPIs';
                            tabData['selectedApiExecutorPlan'] = this.apiExecutorPlans[i];
                            tabData['index'] = i;
                            this.renderedThirdpartyAPIs.push(i);
                            break;
                        }
                    }
                    break;
            }
            if (Object.keys(tabData).length) {
                this.tabData.push(tabData);
                this.activeTabIndex = this.tabData.length - 1;
            }
        }
    }

    onDataMigrationItemSelected(item, dataMigrationPlan) {
        $('.data-migration-menu li').removeClass('active');
        $(item.target).addClass('active');
        this.selectedDataMigrationPlan = dataMigrationPlan;
    }

    selectedTabChanged(currentTab) {
        this.currentTabIndex = currentTab.index;
    }

    onBlocklyRendered(isBlocklyRendered, index) {
        this.tabData[index]['blocklyRendered'] = true;
    }

    closeTab(index) {
        switch (this.tabData[index].type) {
            case 'tables':
                const tableIndex = this.renderedTables.indexOf(this.tabData[index].index);
                this.renderedTables.splice(tableIndex, 1);
                break;
            case 'dataAccessAPIs':
                const dataAccessAPIIndex = this.renderedDataAccessAPIs.indexOf(this.tabData[index].index);
                this.renderedDataAccessAPIs.splice(dataAccessAPIIndex, 1);
                break;
            case 'businessLogicAPIs':
                const businessLogicAPIIndex = this.renderedBusinessLogicAPIs.indexOf(this.tabData[index].index);
                this.renderedBusinessLogicAPIs.splice(businessLogicAPIIndex, 1);
                break;
            case 'sqlQueryAPIs':
                const sqlAPIIndex = this.renderedSQLQueryAPIs.indexOf(this.tabData[index].index);
                this.renderedSQLQueryAPIs.splice(sqlAPIIndex, 1);
                break;
            case 'plSqlAPIs':
                const plsqlAPIIndex = this.renderedPLSQLQueryAPIs.indexOf(this.tabData[index].index);
                this.renderedPLSQLQueryAPIs.splice(plsqlAPIIndex, 1);
                break;
            case 'workflowAPIs':
                const workflowAPIIndex = this.renderedWorkFlowAPIs.indexOf(this.tabData[index].index);
                this.renderedWorkFlowAPIs.splice(workflowAPIIndex, 1);
                break;
            case 'thirdpartyAPIs':
                const thirdpartyAPIIndex = this.renderedThirdpartyAPIs.indexOf(this.tabData[index].index);
                this.renderedThirdpartyAPIs.splice(thirdpartyAPIIndex, 1);
                break;
        }
        this.tabData.splice(index, 1);
        this.activeTabIndex = this.tabData.length - 1;
    }

    onSaveBlocks(executor, i) {
        this.apiExecutorPlans[i].apiExecutor.source = executor.source;
        this.apiExecutorPlans[i].apiExecutor.executors = executor.executors;
        this.apiExecutorPlans[i].apiExecutor.block_attributes = executor.block_attributes;

        this.apiExecutorPlans[i].apiExecutor.executor_name = executor.executor_name;
        this.apiExecutorPlans[i].apiExecutor.executor_version = executor.executor_version;
        this.apiExecutorPlans[i].apiExecutor.executor_display_name = executor.executor_display_name;
        this.apiExecutorPlans[i].apiExecutor.executor_description = executor.executor_description;
        this.apiExecutorPlans[i].apiExecutor.executor_category = executor.executor_category;
        this.apiExecutorPlans[i].apiExecutor.published = executor.published;
        this.apiExecutorPlans[i].apiExecutor.scopeOfAccess = executor.scopeOfAccess;
        this.apiExecutorPlans[i].apiExecutor.executor_method_type = executor.executor_method_type;
        this.apiExecutorPlans[i].apiExecutor.queryParams = executor.queryParams;
        this.apiExecutorPlans[i].apiExecutor.headers = executor.headers;
        this.apiExecutorPlans[i].apiExecutor.requestBody = executor.requestBody;
        this.apiExecutorPlans[i].apiExecutor.executor_method_type = executor.executor_method_type;

        this.platform.openSnackBar('API has been saved successfully.', 'Success', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    async saveExecutor(executor, i) {
        let apiExists = false;
        let error = false;
        let errorType = '';
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        await Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(executor.executor_name, executor.executor_version)).then(response => {
            apiExists = false;
        }, error1 => {
            if (error1.status === 'already exists') {
                apiExists = true;
                errorType = error1.type;
            } else {
                error = true;
            }
        });
        loaderDialog.close();

        if (!error) {
            if (apiExists && errorType === 'entity') {
                this.platform.openSnackBar('Error while saving API. A Data Access API exists with the same provided API name and version.', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                const that = this;
                const matches = this.deploymentPlanMenu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu.filter(function (e) {
                    return e.name === that.apiExecutorPlans[i].apiExecutor.executor_name && e.version === that.apiExecutorPlans[i].apiExecutor.executor_version;
                });
                this.deploymentPlanMenu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index].name = executor.executor_name;
                this.deploymentPlanMenu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index].version = executor.executor_version;
                this.apiExecutorPlans[i].isAvailable = apiExists;
                this.apiExecutorPlans[i].override_api = apiExists ? this.apiExecutorPlans[i].deploy_api : false;
                this.apiExecutorPlans[i].apiExecutor.source = executor.source;
                this.apiExecutorPlans[i].apiExecutor.executors = executor.executors;
                this.apiExecutorPlans[i].apiExecutor.block_attributes = executor.block_attributes;

                this.apiExecutorPlans[i].apiExecutor.executor_name = executor.executor_name;
                this.apiExecutorPlans[i].apiExecutor.executor_version = executor.executor_version;
                this.apiExecutorPlans[i].apiExecutor.executor_display_name = executor.executor_display_name;
                this.apiExecutorPlans[i].apiExecutor.executor_description = executor.executor_description;

                this.apiExecutorPlans[i].apiExecutor.executor_category = executor.executor_category;
                this.apiExecutorPlans[i].apiExecutor.executor_category_group = executor.executor_category_group;
                this.apiExecutorPlans[i].apiExecutor.service_provider = executor.service_provider;

                this.apiExecutorPlans[i].apiExecutor.published = executor.published;
                this.apiExecutorPlans[i].apiExecutor.scopeOfAccess = executor.scopeOfAccess ? executor.scopeOfAccess : executor.executor_scope;
                this.apiExecutorPlans[i].apiExecutor.executor_method_type = executor.executor_method_type;
                this.apiExecutorPlans[i].apiExecutor.queryParams = executor.queryParams;
                this.apiExecutorPlans[i].apiExecutor.headers = executor.headers;
                this.apiExecutorPlans[i].apiExecutor.requestBody = executor.requestBody;
                this.apiExecutorPlans[i].apiExecutor.mockResponses = executor.mockResponses ? executor.mockResponses : [] ;
                this.apiExecutorPlans[i].apiExecutor.executor_method_type = executor.executor_method_type;
                this.apiExecutorPlans[i].apiExecutor.gatewaySettings = executor.gatewaySettings;
                this.apiExecutorPlans[i].apiExecutor.registeredAsIs = executor.registeredAsIs ? executor.registeredAsIs : false;
                this.platform.openSnackBar('API has been saved successfully.', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }

        } else {
            this.platform.openSnackBar('Error while saving API. Please try again later.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    listenAPICreation(timestamp, apiName, apiVersion, index, type) {
        if (this.websocketService.isOpen()) {
            this.websocketService.listenAPICreation(localStorage.getItem('partner'), localStorage.getItem('account'), apiName, apiVersion, localStorage.getItem('sessionID'), timestamp, 'deploy').subscribe(data => {
                //data = JSON.parse(data.body);
                if (data) {
                    this.currentMessage = JSON.parse(data.body);
                    if (this.currentMessage['title'] === 'DONE') {
                        if (type === 'dataAccess') {
                            this.deploymentPlanMenu[0].submenu[index].deployed = 'success';
                        } else if (type === 'businessLogic') {
                            this.deploymentPlanMenu[1].submenu[index].deployed = 'success';
                        }
                    } else {
                        if (this.currentMessage['message'].type === 'fatal') {
                            if (type === 'dataAccess') {
                                this.deploymentPlanMenu[0].submenu[index].deployed = 'error';
                            } else if (type === 'businessLogic') {
                                this.deploymentPlanMenu[1].submenu[index].deployed = 'error';
                            }
                        }
                    }
                }
            });
        }
    }

    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    deployAPIs(menu) {
        this.flaggedEntities = [];
        this.flaggedSql = [];
        this.flaggedWorkflow = [];

        const apiNameVer = [];
        if (this.entityPlans) {
            for (let i = 0; i < this.entityPlans.length; i++) {
                const apiName = this.entityPlans[i].entity.entityname + '(' + this.entityPlans[i].entity.version + ')';
                if (this.entityPlans[i].deploy_api && !(this.databaseNames.includes(this.entityPlans[i].entity.database))) {
                    this.flaggedEntities.push(apiName);
                }
                apiNameVer.push(apiName);
            }
        }

        if (this.apiExecutorPlans) {
            for (let i = 0; i < this.apiExecutorPlans.length; i++) {
                const apiName = this.apiExecutorPlans[i].apiExecutor.executor_name + '(' + this.apiExecutorPlans[i].apiExecutor.executor_version + ')';
                if (this.apiExecutorPlans[i].deploy_api && (this.apiExecutorPlans[i].apiExecutor.executor_type === 'SQLQUERY' || this.apiExecutorPlans[i].apiExecutor.executor_type === 'PLSQL')) {
                    if (!(this.databaseNames.includes(this.apiExecutorPlans[i].apiExecutor.executors[0].database.database_name))) {
                        this.flaggedSql.push(apiName);
                    }
                } else if (this.apiExecutorPlans[i].deploy_api && this.apiExecutorPlans[i].apiExecutor.executor_type === 'WORKFLOW') {
                    if (!(this.apiExecutorPlans[i].apiExecutor.source !== null && this.apiExecutorPlans[i].apiExecutor.source !== '')) {
                        this.flaggedWorkflow.push(apiName);
                    }
                }
                if (this.apiExecutorPlans[i].deploy_api) {
                    apiNameVer.push(apiName);
                }
            }
        }

        const findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) !== index);
        const duplicateApis = [...new Set(findDuplicates(apiNameVer))];

        if (this.flaggedEntities.length || this.flaggedSql.length || this.flaggedWorkflow.length || duplicateApis.length) {
            const dialogRef = this.dialog.open(ConfirmDatabaseDialogComponent, {
                width: '40%',
                data: {
                    flaggedEntities: this.flaggedEntities,
                    flaggedSql: this.flaggedSql,
                    flaggedWorkflow: this.flaggedWorkflow,
                    duplicateApis: duplicateApis
                }
            });
        } else {
            this.transform(menu);
        }

    }

    deployIndividualAPI(menuItem) {
        const menu = menuItem.menu;
        const isEntity = (menuItem.index === 0);
        let index: any;
        if (isEntity) {
            index = menu.index;
        } else {
            index = this.apiExecutorPlans.findIndex(value => value['apiExecutor'] ? ((value['apiExecutor']['executor_name'] === menu['name']) && value['apiExecutor']['executor_version'] === menu['version']) : -1);
        }

        if (index !== -1) {
            this.transform(this.deploymentPlanMenu, {isIndividualDeploy: true, isEntity: isEntity, apiModelIndex: index});
        } else {
            this.platform.openSnackBar('Unable to process the action. Invalid configurations found.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    async transform(menu, config = {isIndividualDeploy: false, isEntity: false, apiModelIndex: null}) {
        this.currentMessage = '';
        this.timeStamp = Date.now();
        if (await this.websocketService.checkConnection()) {
            this.connection = true;
        } else {
            this.connection = false;
        }
        this.action = 'deploy';
        this.entitiesToBeTransformed = [];
        this.executorsToBeTransformed = [];
        if (this.entityPlans && this.entityPlans.length) {
            if (!config.isIndividualDeploy) {
                for (let i = 0; i < this.entityPlans.length; i++) {
                    if (menu[0].submenu[i].checked) {
                        menu[0].submenu[i].deployStarted = false;
                        await this.delay(100);
                        this.entityName = this.entityPlans[i].entity.entityname;
                        this.version = this.entityPlans[i].entity.version;
                        await this.websocketService.checkConnection();
                        // this.deploymentPlanMenu[0].submenu[i].deployStarted = true;
                        const action = this.entityPlans[i].override_api ? 'redeploy' : 'deploy';
                        const timestamp = Date.now();
                        const session = 'session';
                        const topic = localStorage.getItem('partner') + '.' + localStorage.getItem('partner') + '.' + this.entityPlans[i].entity.entityname + '.' + this.entityPlans[i].entity.version + '.' + localStorage.getItem('sessionID') + '.' + timestamp.toString() + '.' + action;

                        this.entityPlans[i]['timestamp'] = timestamp;
                        this.entityPlans[i]['action'] = action;
                        this.entityPlans[i]['session'] = session;
                        
                        const crudApi1 = {
                            'menuRef': this.deploymentPlanMenu[0].submenu[i],
                            'index': i,
                            'topic': topic,
                            'action': action,
                            'apiModel': {
                                'attributes': this.entityPlans[i].entity.attributes,
                                'category': this.entityPlans[i].entity.category,
                                'creationTime': action === 'deploy' ? Date.now() : this.entityPlans[i].entity.categorycreationTime,
                                'database': this.entityPlans[i].entity.database,
                                'description': this.entityPlans[i].entity.description,
                                'displayname': this.entityPlans[i].entity.displayName,
                                'entityname': this.entityPlans[i].entity.entityname,
                                'gatewayManagers': [
                                    'default'
                                ],
                                'lastModifiedTime': Date.now(),
                                'methods': this.entityPlans[i].entity.methods,
                                'published': this.entityPlans[i].entity.published,
                                'registeredAsIs': false,
                                'scopeOfAccess': this.entityPlans[i].entity.scopeOfAccess,
                                'tableCreation': this.entityPlans[i].entity.tableCreation !== null ? this.entityPlans[i].entity.tableCreation : false,
                                'tableName': this.entityPlans[i].entity.entityname,
                                'version': this.entityPlans[i].entity.version
                            }
                        };

                        if (this.dataMigrationPlans) {
                            crudApi1['isTransformData'] = true;
                            crudApi1['transformData'] = {
                                deploymentPlan: {
                                    entityDeploymentPlans: [
                                        this.entityPlans[i]
                                    ],
                                    dataMigrationPlans: [
                                        this.dataMigrationPlans[i]
                                    ],
                                    requestModel: this.requestModel
                                },
                                topic: topic
                            };
                        }
                        this.entitiesToBeTransformed.push(crudApi1);
                    }
                }
            } else {
                if (config.isEntity) {
                    const i = config.apiModelIndex;
                    menu[0].submenu[i].deployStarted = false;
                    this.entityName = this.entityPlans[i].entity.entityname;
                    this.version = this.entityPlans[i].entity.version;
                    await this.websocketService.checkConnection();
                    // this.deploymentPlanMenu[0].submenu[i].deployStarted = true;

                    const action = this.entityPlans[i].isAvailable ? 'redeploy' : 'deploy';
                    const timestamp = Date.now();
                    const session = 'session';
                    const topic = localStorage.getItem('partner') + '.' + localStorage.getItem('partner') + '.' + this.entityPlans[i].entity.entityname + '.' + this.entityPlans[i].entity.version + '.' + localStorage.getItem('sessionID') + '.' + timestamp.toString() + '.' + action;

                    this.entityPlans[i]['timestamp'] = timestamp;
                    this.entityPlans[i]['action'] = action;
                    this.entityPlans[i]['session'] = session;

                    const crudApi1 = {
                        'menuRef': this.deploymentPlanMenu[0].submenu[i],
                        'index': i,
                        'topic': topic,
                        'action': action,
                        'apiModel': {
                            'attributes': this.entityPlans[i].entity.attributes,
                            'category': this.entityPlans[i].entity.category,
                            'creationTime': action === 'deploy' ? Date.now() : this.entityPlans[i].entity.categorycreationTime,
                            'database': this.entityPlans[i].entity.database,
                            'description': this.entityPlans[i].entity.description,
                            'displayname': this.entityPlans[i].entity.displayName,
                            'entityname': this.entityPlans[i].entity.entityname,
                            'gatewayManagers': [
                                'default'
                            ],
                            'lastModifiedTime': Date.now(),
                            'methods': this.entityPlans[i].entity.methods,
                            'published': this.entityPlans[i].entity.published,
                            'registeredAsIs': false,
                            'scopeOfAccess': this.entityPlans[i].entity.scopeOfAccess,
                            'tableCreation': this.entityPlans[i].entity.tableCreation !== null ? this.entityPlans[i].entity.tableCreation : false,
                            'tableName': this.entityPlans[i].entity.entityname,
                            'version': this.entityPlans[i].entity.version
                        }
                    };

                    if (this.dataMigrationPlans) {
                        crudApi1['isTransformData'] = true;
                        crudApi1['transformData'] = {
                            deploymentPlan: {
                                entityDeploymentPlans: [
                                    this.entityPlans[i]
                                ],
                                dataMigrationPlans: [
                                    this.dataMigrationPlans[i]
                                ],
                                requestModel: this.requestModel
                            },
                            topic: topic
                        };
                    }
                    this.entitiesToBeTransformed.push(crudApi1);
                }
            }
        }

        if (this.apiExecutorPlans && this.apiExecutorPlans.length) {
            if (!config.isIndividualDeploy) {
                for (let i = 0; i < this.apiExecutorPlans.length; i++) {
                    const that = this;
                    const matches = menu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu.filter(function (e) {
                        return e.name === that.apiExecutorPlans[i].apiExecutor.executor_name && e.version === that.apiExecutorPlans[i].apiExecutor.executor_version;
                    });
                    if (menu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index].checked) {
                        menu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index].deployStarted = false;

                        this.entityName = this.apiExecutorPlans[i].apiExecutor.executor_name;
                        this.version = this.apiExecutorPlans[i].apiExecutor.executor_version;
                        // menu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index].deployStarted = true;

                        const fabResult = {
                            'executor_type': this.apiExecutorPlans[i].apiExecutor.executor_type,
                            'executor_name': this.apiExecutorPlans[i].apiExecutor.executor_name,
                            'executor_version': this.apiExecutorPlans[i].apiExecutor.executor_version,
                            'executor_display_name': this.apiExecutorPlans[i].apiExecutor.executor_display_name,
                            'executor_description': this.apiExecutorPlans[i].apiExecutor.executor_description,
                            'executor_category': this.apiExecutorPlans[i].apiExecutor.executor_category,
                            'executor_category_group': this.apiExecutorPlans[i].apiExecutor.executor_category_group,
                            'service_provider': this.apiExecutorPlans[i].apiExecutor.service_provider,
                            'executor_method_type': this.apiExecutorPlans[i].apiExecutor.executor_method_type,
                            'queryParams': this.apiExecutorPlans[i].apiExecutor.queryParams,
                            'headers': this.apiExecutorPlans[i].apiExecutor.headers,
                            'requestBody': this.apiExecutorPlans[i].apiExecutor.requestBody,
                            'published': this.apiExecutorPlans[i].apiExecutor.published,
                            'scopeOfAccess': this.apiExecutorPlans[i].apiExecutor.scopeOfAccess,
                            'creationTime': Date.now(),
                            'lastModifiedTime': Date.now(),
                            'registeredAsIs': this.apiExecutorPlans[i].apiExecutor.registeredAsIs,
                            'prerequisites': this.apiExecutorPlans[i].apiExecutor.prerequisites,
                            'source': this.apiExecutorPlans[i].apiExecutor.source ? this.apiExecutorPlans[i].apiExecutor.source : '<xml xmlns="https://developers.google.com/blockly/xml"></xml>',
                            'executors': this.apiExecutorPlans[i].apiExecutor.executors ? this.apiExecutorPlans[i].apiExecutor.executors : [],
                            'partner': this.partner,
                            'account_id': this.account,
                            'apiUrl': this.apiExecutorPlans[i].apiExecutor.apiUrl,
                            'dataroot': this.apiExecutorPlans[i].apiExecutor.dataroot,
                            'responseAttributes': this.apiExecutorPlans[i].apiExecutor.responseAttributes,
                            'attributeMappings': this.apiExecutorPlans[i].apiExecutor.attributeMappings,
                            'response': this.apiExecutorPlans[i].apiExecutor.response,
                            'block_attributes': this.apiExecutorPlans[i].apiExecutor.block_attributes,
                            'mockResponses': this.apiExecutorPlans[i].apiExecutor.mockResponses ? this.apiExecutorPlans[i].apiExecutor.mockResponses : [],
                            'timeStamp': this.timeStamp,
                            'sessionId': localStorage.getItem('sessionID'),
                            'action': this.action,
                            'editFlag': false
                        };
                        fabResult['authModel'] = this.apiExecutorPlans[i].apiExecutor.authModel;

                        

                        const timestamp = Date.now();
                        const session = 'session';
                        const action = this.apiExecutorPlans[i].override_api ? 'redeploy' : 'deploy';
                        const topic = localStorage.getItem('partner') + '.' + localStorage.getItem('partner') + '.' + this.apiExecutorPlans[i].apiExecutor.executor_name + '.' + this.apiExecutorPlans[i].apiExecutor.executor_version + '.' + localStorage.getItem('sessionID') + '.' + timestamp.toString() + '.' + action;

                        this.apiExecutorPlans[i]['timestamp'] = timestamp;
                        this.apiExecutorPlans[i]['action'] = action;
                        this.apiExecutorPlans[i]['session'] = session;

                        const executorPayload1 = {
                            'index': i,
                            'menuRef': menu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index],
                            'topic': topic,
                            'action': action,
                            'apiModel': {
                                'executor_type': this.apiExecutorPlans[i].apiExecutor.executor_type,
                                'executor_name': this.apiExecutorPlans[i].apiExecutor.executor_name,
                                'executor_version': this.apiExecutorPlans[i].apiExecutor.executor_version,
                                'executor_display_name': this.apiExecutorPlans[i].apiExecutor.executor_display_name,
                                'executor_description': this.apiExecutorPlans[i].apiExecutor.executor_description,
                                'executor_category_group': this.apiExecutorPlans[i].apiExecutor.executor_category_group,
                                'service_provider': this.apiExecutorPlans[i].apiExecutor.service_provider,
                                'executor_category': this.apiExecutorPlans[i].apiExecutor.executor_category,
                                'executor_method_type': this.apiExecutorPlans[i].apiExecutor.executor_method_type,
                                'queryParams': this.apiExecutorPlans[i].apiExecutor.queryParams,
                                'headers': this.apiExecutorPlans[i].apiExecutor.headers,
                                'requestBody': this.apiExecutorPlans[i].apiExecutor.requestBody,
                                'published': this.apiExecutorPlans[i].apiExecutor.published,
                                'executor_scope': this.apiExecutorPlans[i].apiExecutor.scopeOfAccess,
                                'scopeOfAccess': this.apiExecutorPlans[i].apiExecutor.scopeOfAccess,
                                'authModel': this.apiExecutorPlans[i].apiExecutor.authModel,
                                'creationTime': action === 'deploy' ? Date.now() : this.apiExecutorPlans[i].apiExecutor.creationTime,
                                'lastModifiedTime': Date.now(),
                                'registeredAsIs': this.apiExecutorPlans[i].apiExecutor.registeredAsIs,
                                'prerequisites': this.apiExecutorPlans[i].apiExecutor.prerequisites,
                                'source': this.apiExecutorPlans[i].apiExecutor.source !== null || this.apiExecutorPlans[i].apiExecutor.source !== '' ? this.apiExecutorPlans[i].apiExecutor.source : this.apiExecutorPlans[i].apiExecutor.executor_type === 'BUSINESSLOGIC' ? '<xml xmlns="https://developers.google.com/blockly/xml"></xml>' : '',
                                'executors': this.apiExecutorPlans[i].apiExecutor.executors ? this.apiExecutorPlans[i].apiExecutor.executors : [],
                                'partner': this.partner,
                                'account_id': this.account,
                                'apiUrl': this.apiExecutorPlans[i].apiExecutor.apiUrl,
                                'dataroot': this.apiExecutorPlans[i].apiExecutor.dataroot,
                                'responseAttributes': this.apiExecutorPlans[i].apiExecutor.responseAttributes,
                                'mockResponses': this.apiExecutorPlans[i].apiExecutor.mockResponses ? this.apiExecutorPlans[i].apiExecutor.mockResponses : [],
                                'attributeMappings': this.apiExecutorPlans[i].apiExecutor.attributeMappings,
                                'response': this.apiExecutorPlans[i].apiExecutor.response,
                                'block_attributes': this.apiExecutorPlans[i].apiExecutor.block_attributes,
                            }
                        };

                        this.executorsToBeTransformed.push(executorPayload1);
                    }
                }
            } else {
                if (!config.isEntity) {
                    const i = config.apiModelIndex;
                    const that = this;
                    const matches = menu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu.filter(function (e) {
                        return e.name === that.apiExecutorPlans[i].apiExecutor.executor_name && e.version === that.apiExecutorPlans[i].apiExecutor.executor_version;
                    });
                    menu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index].deployStarted = false;
                    this.entityName = this.apiExecutorPlans[i].apiExecutor.executor_name;
                    this.version = this.apiExecutorPlans[i].apiExecutor.executor_version;

                    const action = this.apiExecutorPlans[i].isAvailable ? 'redeploy' : 'deploy';
                    const timestamp = Date.now();
                    const session = 'session';
                    const topic = localStorage.getItem('partner') + '.' + localStorage.getItem('partner') + '.' + this.apiExecutorPlans[i].apiExecutor.executor_name + '.' + this.apiExecutorPlans[i].apiExecutor.executor_version + '.' + localStorage.getItem('sessionID') + '.' + timestamp.toString() + '.' + action;

                    this.apiExecutorPlans[i]['timestamp'] = timestamp;
                    this.apiExecutorPlans[i]['action'] = action;
                    this.apiExecutorPlans[i]['session'] = session;
                    const executorPayload1 = {
                        'index': i,
                        'menuRef': menu[this.getMenuIndex(this.apiExecutorPlans[i].apiExecutor.executor_type)].submenu[matches[0].index],
                        'topic': topic,
                        'action': action,
                        'apiModel': {
                            'executor_type': this.apiExecutorPlans[i].apiExecutor.executor_type,
                            'executor_name': this.apiExecutorPlans[i].apiExecutor.executor_name,
                            'executor_version': this.apiExecutorPlans[i].apiExecutor.executor_version,
                            'executor_display_name': this.apiExecutorPlans[i].apiExecutor.executor_display_name,
                            'executor_description': this.apiExecutorPlans[i].apiExecutor.executor_description,
                            'executor_category_group': this.apiExecutorPlans[i].apiExecutor.executor_category_group,
                            'service_provider': this.apiExecutorPlans[i].apiExecutor.service_provider,
                            'executor_category': this.apiExecutorPlans[i].apiExecutor.executor_category,
                            'executor_method_type': this.apiExecutorPlans[i].apiExecutor.executor_method_type,
                            'queryParams': this.apiExecutorPlans[i].apiExecutor.queryParams,
                            'headers': this.apiExecutorPlans[i].apiExecutor.headers,
                            'requestBody': this.apiExecutorPlans[i].apiExecutor.requestBody,
                            'published': this.apiExecutorPlans[i].apiExecutor.published,
                            'executor_scope': this.apiExecutorPlans[i].apiExecutor.scopeOfAccess,
                            'scopeOfAccess': this.apiExecutorPlans[i].apiExecutor.scopeOfAccess,
                            'authModel': this.apiExecutorPlans[i].apiExecutor.authModel,
                            'creationTime': action === 'deploy' ? Date.now() : this.apiExecutorPlans[i].apiExecutor.creationTime,
                            'lastModifiedTime': Date.now(),
                            'registeredAsIs': this.apiExecutorPlans[i].apiExecutor.registeredAsIs,
                            'prerequisites': this.apiExecutorPlans[i].apiExecutor.prerequisites,
                            'source': this.apiExecutorPlans[i].apiExecutor.source !== null || this.apiExecutorPlans[i].apiExecutor.source !== '' ? this.apiExecutorPlans[i].apiExecutor.source : this.apiExecutorPlans[i].apiExecutor.executor_type === 'BUSINESSLOGIC' ? '<xml xmlns="https://developers.google.com/blockly/xml"></xml>' : '',
                            'executors': this.apiExecutorPlans[i].apiExecutor.executors ? this.apiExecutorPlans[i].apiExecutor.executors : [],
                            'partner': this.partner,
                            'account_id': this.account,
                            'apiUrl': this.apiExecutorPlans[i].apiExecutor.apiUrl,
                            'dataroot': this.apiExecutorPlans[i].apiExecutor.dataroot,
                            'responseAttributes': this.apiExecutorPlans[i].apiExecutor.responseAttributes,
                            'attributeMappings': this.apiExecutorPlans[i].apiExecutor.attributeMappings,
                            'response': this.apiExecutorPlans[i].apiExecutor.response,
                            'block_attributes': this.apiExecutorPlans[i].apiExecutor.block_attributes,
                        }
                    };

                    this.executorsToBeTransformed.push(executorPayload1);

                }
            }
        }

        if (this.type === 'openAPI') {
            this.applicationData.servers.length = 0;
            this.serverUrls.forEach(server => {
                this.applicationData.servers.push({url: server});
            });
            const categories = this.categoriesData.map(a => a.name);
            const categoryList = [];

            let errorInCreation = false;
            let errorMessage = '';

            let createApplication = false;
            let edit = this.editFlag;
            this.depolymentLoading = true;
            if (this.editFlag && (this.origApplicationData.title !== this.applicationData.title || this.origApplicationData.version !== this.applicationData.version)) {
                let message = '';
                if (this.origApplicationData.title !== this.applicationData.title) {
                    if (this.origApplicationData.version !== this.applicationData.version) {
                        message = 'Both the title and version of the application have been changed. Hence this will create another application : ' + this.applicationData.title + ' with the version: ' + this.applicationData.version + '. Do you want to continue creating a new Application ?';
                    } else {
                        message = 'Title of the application has been changed. Hence this will create another application : ' + this.applicationData.title + ' with the version: ' + this.applicationData.version + '. Do you want to continue creating a new Application ?';
                    }
                } else {
                    if (this.origApplicationData.version !== this.applicationData.version) {
                        message = 'Version of the application has been changed. Hence this will create another application : ' + this.applicationData.title + ' with the version: ' + this.applicationData.version + '. Do you want to continue creating a new Application ?';
                    }
                }
                const publishData = {
                    title: this.applicationData.title,
                    version: this.applicationData.version,
                    message: message,
                    type: 'create'
                };
                const dialogRef = this.dialog.open(ApplicationVersionChangeConfirmationComponent, {
                    width: '60%',
                    data: publishData
                });

                const result = await dialogRef.afterClosed().toPromise();
                if (result) {
                    createApplication = true;
                    edit = false;
                } else {
                    this.depolymentLoading = false;
                }
            } else {
                createApplication = true;
            }

            if (createApplication) {
                this.confPost.getData('services', 'services', 'v1', 'categories', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&name=' + categories.join(',')).subscribe(async response => {
                    this.categoryResponse = response;
                    await Promise.all(this.categoriesData.map(async (category) => {
                        const obj = this.categoryResponse.find(o => o.name === category.name);
                        if (obj) {
                            categoryList.push(obj.id);
                        } else {
                            const payload = {
                                partner: this.partner,
                                account: this.account,
                                name: category.name,
                                description: category.description
                            };
                            const categoryId = await this.createCategory(payload);
                            if (categoryId !== 'failed') {
                                categoryList.push(categoryId);
                            } else {
                                errorInCreation = true;
                                errorMessage = 'Error while creating categories. Please try again later.';
                            }
                        }
                    }));
                    if (!errorInCreation) {
                        this.confPost.getData('services', 'services', 'v1', 'application', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&title=' + this.applicationData.title + '&version=' + this.applicationData.version).subscribe(async resp => {
                            this.applicationResponse = resp;
                            if (this.applicationResponse.length > 0) {
                                // this.platform.openSnackBar('An Application with the provided title and version already exists.', 'Error', {
                                //     duration: 10000,
                                //     verticalPosition: 'top',
                                //     horizontalPosition: 'center'
                                // });


                                let result = false;
                                if (!edit) {
                                    const publishData = {
                                        title: this.applicationData.title,
                                        version: this.applicationData.version,
                                        message: 'An Application with the provided title and version already exists. You can change the title and version to create a new Application. Or do you want to update the existing Application ?',
                                        type: 'update'
                                    };
                                    const dialogRef = this.dialog.open(ApplicationVersionChangeConfirmationComponent, {
                                        width: '60%',
                                        data: publishData
                                    });
                                    result = await dialogRef.afterClosed().toPromise();
                                } else {
                                    result = true;
                                }

                                const updatePayload = JSON.parse(JSON.stringify(this.applicationData));
                                updatePayload['categories'] = categoryList;
                                updatePayload['lastModifiedTime'] = Date.now();
                                if (result) {
                                    Promise.resolve(this.updateApplication(this.applicationResponse[0]['id'], updatePayload)).then(response1 => {
                                        this.origApplicationData = JSON.parse(JSON.stringify(this.applicationData));
                                        this.leftPanelDataListener.changeInLeftPanelData.emit('application');
                                        Promise.resolve(this.deployApis()).then(response2 => {
                                            this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                            this.depolymentLoading = false;
                                        });

                                    }, error => {
                                        this.depolymentLoading = false;
                                        this.platform.openSnackBar('Error while updating Application, Please try again later.', 'Error', {
                                            duration: 10000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    });
                                } else {
                                    this.depolymentLoading = false;
                                }
                            } else {
                                const applicationPayload = JSON.parse(JSON.stringify(this.applicationData));
                                applicationPayload['partner'] = this.partner;
                                applicationPayload['account'] = this.account;
                                applicationPayload['categories'] = categoryList;
                                applicationPayload['creationTime'] = Date.now();
                                applicationPayload['lastModifiedTime'] = Date.now();

                                Promise.resolve(this.createApplication(applicationPayload)).then(response1 => {
                                    this.origApplicationData = JSON.parse(JSON.stringify(applicationPayload));
                                    this.leftPanelDataListener.changeInLeftPanelData.emit('application');
                                    Promise.resolve(this.deployApis()).then(response2 => {
                                        this.depolymentLoading = false;
                                        this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                    });

                                }, error => {
                                    this.depolymentLoading = false;
                                    this.platform.openSnackBar('Error while creating Application, Please try again later.', 'Error', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                });
                            }
                        }, error1 => {
                            this.depolymentLoading = false;
                            this.platform.openSnackBar('Error while creating Application, Please try again later.', 'Error', {
                                duration: 10000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                    } else {
                        this.depolymentLoading = false;
                    }

                }, error => {
                    this.depolymentLoading = false;
                    this.platform.openSnackBar('Error while creating Application, Please try again later.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }
        } else {
            this.depolymentLoading = true;
            Promise.resolve(this.deployApis()).then(response2 => {
                this.depolymentLoading = false;
                // const dialogRef = this.dialog.open(DeploymentSummaryComponent, {
                //     height: '60%',
                //     width: '60%',
                //     data: {sourceDatabase: this.deploymentPlan.requestModel.sourceDatabaseName, status: this.deploymentPlanMenu}
                // });
                this.leftPanelDataListener.changeInLeftPanelData.emit('update');
            });
        }
        // } else {
        //
        // }
        // for (const crudApi of this.entitiesToBeTransformed) {
        //     this.confPost.insertEntityDuplicate(crudApi).subscribe(response => {
        //         if (response) {
        //             this.setAPIDeploymentStatus(crudApi.entity.entityname, crudApi.entity.version, 'success');
        //             // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
        //         }
        //     }, error => {
        //         this.setAPIDeploymentStatus(crudApi.entity.entityname, crudApi.entity.version, 'failure');
        //     });
        // }
        // for (const executor of this.executorsToBeTransformed) {
        //     this.confPost.insertExecutorDuplicate(executor).subscribe(response => {
        //         if (response) {
        //             this.setAPIDeploymentStatus(executor.executor.executor_name, executor.executor.executor_version, 'success');
        //             // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
        //         }
        //     }, error => {
        //         this.setAPIDeploymentStatus(executor.executor.executor_name, executor.executor.executor_version, 'failure');
        //     });
        // }

        // this.apiCreatorService.createDaa(this.entitiesToBeTransformed);
        // this.apiCreatorService.createBusinessLogicApi(this.partner, this.account, this.executorsToBeTransformed, this.timeStamp);
    }

    deployApis() {
        return new Promise((resolve, reject) => {
            const promises = [];
            for (const crudApi of this.entitiesToBeTransformed) {
                const promise = new Promise((resolve1, reject1) => {
                    crudApi.menuRef.deployStarted = true;
                    delete crudApi['menuRef'];
                    const payload = JSON.parse(JSON.stringify(crudApi));
                    delete payload['action'];
                    // this.confPost.insertEntityWithAPI(crudApi).toPromise().then(response => {
                    this.setAPIDeploymentStatus(crudApi.apiModel.entityname, crudApi.apiModel.version, 'loading');

                    if (!crudApi.isTransformData) {
                        this.confPost.upsertAPIWithCore(this.accountInfoService.partner, this.accountInfoService.account, this.accountInfoService.partnerKey,
                            payload, true, crudApi.action === 'redeploy', true, true).toPromise().then(response => {

                            if (response) {
                                this.setAPIDeploymentStatus(crudApi.apiModel.entityname, crudApi.apiModel.version, 'success');
                                // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                            }
                            resolve1('success');
                        }, error => {

                            this.setAPIDeploymentStatus(crudApi.apiModel.entityname, crudApi.apiModel.version, 'failure');
                            resolve1('failure');
                        });
                    } else {
                        this.apiService.dataTransformationWithCore(payload.transformData).toPromise().then(response => {

                            if (response) {
                                this.setAPIDeploymentStatus(crudApi.apiModel.entityname, crudApi.apiModel.version, 'success');
                                // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                            }
                            resolve1('success');
                        }, error => {

                            this.setAPIDeploymentStatus(crudApi.apiModel.entityname, crudApi.apiModel.version, 'failure');
                            resolve1('failure');
                        });
                    }
                });
                promises.push(promise);
            }
            for (const executor of this.executorsToBeTransformed) {
                executor.menuRef.deployStarted = true;
                delete executor['menuRef'];
                const promise = new Promise((resolve1, reject1) => {
                    // this.confPost.insertExecutorWithAPI(executor).toPromise().then(response => {
                    const payload = JSON.parse(JSON.stringify(executor));
                    delete payload['action'];
                    this.setAPIDeploymentStatus(executor.apiModel.executor_name, executor.apiModel.executor_version, 'loading');
                    this.confPost.upsertAPIWithCore(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey'), payload, false, executor.action === 'redeploy', true, true).toPromise().then(response => {
                        if (response) {
                            this.setAPIDeploymentStatus(executor.apiModel.executor_name, executor.apiModel.executor_version, 'success');
                            // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                        }
                        resolve1('success');
                    }, error => {
                        this.setAPIDeploymentStatus(executor.apiModel.executor_name, executor.apiModel.executor_version, 'failure');
                        resolve1('failure');
                    });
                });
                promises.push(promise);
            }

            Promise.all(promises)
                .then(async (results) => {
                    resolve('success');
                });
        });
    }


    createCategory(payload) {
        return new Promise((resolve, reject) => {
            this._service.addItem(payload, 'v1', 'services', 'services', 'categories').subscribe(async response => {
                resolve(response['upsertedId']);
            }, async error => {
                resolve('failed');
            });
        });
    }

    createApplication(payload) {
        return new Promise((resolve, reject) => {
            this._service.addItem(payload, 'v1', 'services', 'services', 'application').subscribe(async response => {
                resolve(response['upsertedId']);
            }, async error => {
                reject(error);
            });
        });
    }

    updateApplication(id, payload) {
        return new Promise((resolve, reject) => {
            this._service.patchItemUpdate(id, payload, 'v1', 'services', 'services', 'application').subscribe(async response => {
                resolve(response['upsertedId']);
            }, async error => {
                reject(error);
            });
        });
    }

    closeLogPanel() {
        this.logVisible = false;
        this.componentRef.destroy();
        this.guard = 0;
    }

    showLogs(selectedItem) {
        if (!this.logVisible) {
            this.logVisible = true;
        }
        switch (selectedItem.parent) {
            case 'Tables':
                for (let i = 0; i < this.entityPlans.length; i++) {
                    if (this.entityPlans[i].entity.entityname === selectedItem.child) {
                        this.entityName = this.entityPlans[i].entity.entityname;
                        this.version = this.entityPlans[i].entity.version;
                        this.logVisible = true;
                        this.action = this.entityPlans[i].isAvailable ? 'redeploy' : 'deploy';
                        if (this.guard === 0) {
                            this.create({timestamp: this.entityPlans[i].timestamp, action: this.entityPlans[i].action});
                        } else {
                            this.componentRef.destroy();
                            this.create({timestamp: this.entityPlans[i].timestamp, action: this.entityPlans[i].action});
                        }
                        break;
                    }
                }
                break;
            case 'Data Access APIs':
                for (let i = 0; i < this.entityPlans.length; i++) {
                    if (this.entityPlans[i].entity.entityname === selectedItem.child) {
                        this.entityName = this.entityPlans[i].entity.entityname;
                        this.version = this.entityPlans[i].entity.version;
                        this.logVisible = true;
                        this.action = this.entityPlans[i].override_api ? 'redeploy' : 'deploy';
                        if (this.guard === 0) {
                            this.create({timestamp: this.entityPlans[i].timestamp, action: this.entityPlans[i].action});
                        } else {
                            this.componentRef.destroy();
                            this.create({timestamp: this.entityPlans[i].timestamp, action: this.entityPlans[i].action});
                        }
                        break;
                    }
                }
                break;
            default:
                for (let i = 0; i < this.apiExecutorPlans.length; i++) {
                    if (this.apiExecutorPlans[i].apiExecutor.executor_name === selectedItem.child) {
                        this.entityName = this.apiExecutorPlans[i].apiExecutor.executor_name;
                        this.version = this.apiExecutorPlans[i].apiExecutor.executor_version;
                        this.logVisible = true;
                        this.action = this.apiExecutorPlans[i].override_api ? 'redeploy' : 'deploy';
                        if (this.guard === 0) {
                            this.create({timestamp: this.apiExecutorPlans[i].timestamp, action: this.apiExecutorPlans[i].action});
                        } else {
                            this.componentRef.destroy();
                            this.create({timestamp: this.apiExecutorPlans[i].timestamp, action: this.apiExecutorPlans[i].action});
                        }
                        break;
                    }
                }
                break;
            // case 'SQL Query APIs':
            //     for (let i = 0; i < this.apiExecutorPlans.length; i++) {
            //         if (this.apiExecutorPlans[i].apiExecutor.executor_name === selectedItem.child) {
            //             this.entityName = this.apiExecutorPlans[i].apiExecutor.executor_name;
            //             this.version = this.apiExecutorPlans[i].apiExecutor.executor_version;
            //             this.logVisible = true;
            //             if (this.guard === 0) {
            //                 this.create();
            //             } else {
            //                 this.componentRef.destroy();
            //                 this.create();
            //             }
            //             break;
            //         }
            //     }
            //     break;
        }
    }

    create(data: any = {session: 'session', timestamp: Date.now(), action: 'deploy'}) {
        this.guard = 1;
        const componentFactory = this._componentFactoryResolver.resolveComponentFactory(ProgressLogsComponent);
        this.componentRef = this.injectComp.viewContainerRef.createComponent(componentFactory);
        // this.action = 'deploy';
        this.componentRef.instance.apiType = this.apiType;
        this.componentRef.instance.entityName = this.entityName;
        this.componentRef.instance.version = this.version;
        // this.componentRef.instance.currentMessage = this.currentMessage;
        this.componentRef.instance.connection = this.connection;
        this.componentRef.instance.action = data.action;
        // this.componentRef.instance.partner = this.partner;
        // this.componentRef.instance.account = this.account;
        // this.componentRef.instance.session = this.session;
        this.componentRef.instance.timeStamp = data.timestamp ? (data.timestamp).toString() : '';
        this.componentRef.instance.refreshCount = 1;
        //this.componentRef.instance.lightbox_open();
        // this.componentRef.instance.CloseClicked.subscribe(res => {
        //     if (res) {
        //         this.componentRef.destroy();
        //         this.guard = 0;
        //     }
        // });
    }

    async saveEntity(entity, i) {
        let apiExists = false;
        let error = false;
        let errorType = '';
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        await Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(entity.entityname, entity.version)).then(response => {
            apiExists = false;
        }, error1 => {
            if (error1.status === 'already exists') {
                apiExists = true;
                errorType = error1.type;
            } else {
                error = true;
            }
        });
        loaderDialog.close();

        if (!error) {
            if (apiExists && errorType === 'executor') {
                this.platform.openSnackBar('Error while saving API. An executor exists with the same provided API name and version.', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                this.deploymentPlanMenu[0].submenu[i].name = entity.entityname;
                this.deploymentPlanMenu[0].submenu[i].version = entity.version;
                this.entityPlans[i].isAvailable = apiExists;
                this.entityPlans[i].override_api = apiExists ? this.entityPlans[i].deploy_api : false;
                this.entityPlans[i].entity.database = entity.database;
                this.entityPlans[i].entity.entityname = entity.entityname;
                this.entityPlans[i].entity.version = entity.version;
                this.entityPlans[i].entity.tableName = entity.tableName;
                // this.entityPlans[i].entity.category = entity.category;
                this.entityPlans[i].entity.attributes = entity.attributes;
                this.entityPlans[i].entity.methods = entity.methods;
                this.entityPlans[i].entity.scopeOfAccess = entity.scope;
                this.entityPlans[i].entity.published = entity.isPublished;
                this.platform.openSnackBar('API has been saved successfully.', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.platform.openSnackBar('Error while saving API. Please try again later.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    refreshComponent() {
        this.goBack.emit();
    }

    toggleExecutor(ev) {
        this.isToggleExpanded = !this.isToggleExpanded;
        $('.application-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;

        // Add our keyword
        if ((value || '').trim()) {
            this.serverUrls.push(value.trim());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    remove(keyword: any): void {
        const index = this.serverUrls.indexOf(keyword);

        if (index >= 0) {
            this.serverUrls.splice(index, 1);
        }
    }
}

@Component({
    selector: 'confirm-database-dialog-component',
    templateUrl: './confirm-database-dialog.html',
    styleUrls: ['./deploymentplan.component.css']
})
export class ConfirmDatabaseDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

}

@Component({
    selector: 'application-version-change-confirmation',
    templateUrl: 'application-version-change-confirmation.component.html',
    styleUrls: ['application-version-change-confirmation.component.css']
})
export class ApplicationVersionChangeConfirmationComponent {
    copyData = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

}
